
import { Fragment, useContext } from "react"
import cn from "classnames"
import { AppContext } from "store/context/AppContext"
import SidebarItems from "components/Core/Layout/Sidebar/SidebarItems"
import usePostRender from "hooks/usePostRender"

interface ISidebar {
  className?: string
}

const Sidebar = ({ className }: ISidebar) => {
  const { open_sidebar } = useContext(AppContext)
  const { loadedPostRender } = usePostRender()

  if (!loadedPostRender) return null

  return (
    <Fragment>
      <div
        className={cn(
          "absolute z-50 w-64 h-[calc(100vh_-_5rem)] hidden lg:flex flex-col items-start justify-start text-black bg-white",
          {
            "-translate-x-64": !open_sidebar,
            "lg:w-20": !open_sidebar,
            "lg:-translate-x-0": !open_sidebar,
          },
          className,
        )}
      >
        <SidebarItems sidebar_opened={open_sidebar} />
      </div>
      <div
        className={cn(
          "absolute w-screen h-[calc(100vh_-_5rem)] lg:hidden flex flex-col items-center justify-start text-black bg-white z-40 transition-transform duration-300",
          {
            "translate-x-0": open_sidebar,
            "-translate-x-full": !open_sidebar,
          },
        )}
      >
        <SidebarItems sidebar_opened={open_sidebar} />
      </div>
    </Fragment>
  )
}

export default Sidebar
